module.exports = __webpack_public_path__ + "static/media/session3icon.ec7911f4.png";